<div class="cell-issues-category-container space-between align-items-center">
  <span class="cell-issues-category-name">{{categoryName}}</span>
  <span class="issues-category-{{category}}"></span>
</div>
